var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full fixed block bg-gray-700 opacity-75 z-50 items-center justify-center"},[_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }